import { render } from "./CourseUrls.vue?vue&type=template&id=12fec65f&scoped=true"
import script from "./CourseUrls.vue?vue&type=script&lang=js"
export * from "./CourseUrls.vue?vue&type=script&lang=js"

import "./CourseUrls.vue?vue&type=style&index=0&id=12fec65f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fec65f"]])

export default __exports__